import { Injectable } from "@angular/core";
import * as moment from "moment";
import { Subject } from "rxjs";

import { IWorkorderQuery, WorkorderField, WorkorderFilterType, WorkorderOrderType, WorkorderSortType } from "../../core/models/workorder.model";
import { StorageService } from "../../core/services/storage.service";

@Injectable()
export class WorkorderQueryService {
	queryChanges$ = new Subject<IWorkorderQuery>();

	initialQuery: IWorkorderQuery = {
		filter: WorkorderFilterType.Today,
		page: 1,
		order: WorkorderOrderType.Ascending,
		search: "",
		sort: WorkorderSortType.PlanningStartDate,
		filterDate: moment().format("YYYY-MM-DD"),
		organization: ""
	};
	private query: IWorkorderQuery;

	constructor(private storageService: StorageService) {}

	getFilter(): string {
		const filter = [];
		filter.push("order_type[eq]:1");
		filter.push("(is_collect[eq]:0,-is_collect[eq]:null)");
		filter.push("(is_ci_printed[eq]:0,-is_ci_printed[eq]:null)");

		if (this.query.filter === WorkorderFilterType.All) {
			filter.push("is_invoiced[eq]:0");
		} else if (this.query.filter === WorkorderFilterType.Yesterday) {
			const startDate = moment().utc(true).subtract(1, "days").startOf("day").format("YYYY-MM-DD");
			const endDate = moment().utc(true).subtract(1, "days").endOf("day").format("YYYY-MM-DD");
			filter.push(`planning_start_date[containsrange]:${startDate};${endDate}`, "is_invoiced[eq]:0");
		} else if (this.query.filter === WorkorderFilterType.Today) {
			const todayDate = moment().utc(true).format("YYYY-MM-DD");
			filter.push(`planning_start_date[rangecontains]:planning_ready_date;${todayDate}`, "is_invoiced[eq]:0");
		} else if (this.query.filter === WorkorderFilterType.Tomorrow) {
			const tomorrowDate = moment().utc(true).add(1, "days").format("YYYY-MM-DD");
			filter.push(`planning_start_date[rangecontains]:planning_ready_date;${tomorrowDate}`, "is_invoiced[eq]:0");
		} else if (this.query.filter === WorkorderFilterType.ThisWeek) {
			const weekStart = moment().utc(true).startOf("week").format("YYYY-MM-DD");
			const weekEnd = moment().utc(true).endOf("week").format("YYYY-MM-DD");
			filter.push(`planning_start_date[containsrange]:${weekStart};${weekEnd}`, "is_invoiced[eq]:0");
		} else if (this.query.filter === WorkorderFilterType.Date) {
			const selectedDate = moment(this.query.filterDate).utc(true).format("YYYY-MM-DD");
			filter.push(`planning_start_date[rangecontains]:planning_ready_date;${selectedDate}`, "is_invoiced[eq]:0");
		}

		if (this.query.organization) filter.push(`organization_id[eq]:${this.query.organization}`);

		return filter.join(",");
	}

	getSort(): string {
		const order = this.query.order === WorkorderOrderType.Ascending ? "" : "-";
		if (this.query.sort === WorkorderSortType.PlanningStartDate) return `${order}${WorkorderField.PlanningStartDate},${order}${WorkorderField.OrderNumber}`;

		if (this.query.sort === WorkorderSortType.OrderNumber) return `${order}${WorkorderField.OrderNumber}`;

		return `${order}${WorkorderField.OrderNumber}`;
	}

	getSearch(): string {
		return this.query.search;
	}

	async init() {
		const query = this.initialQuery;
		if (query) {
			this.query = {
				filter: query.filter,
				page: this.initialQuery.page,
				order: query.order,
				search: this.initialQuery.search,
				sort: query.sort,
				filterDate: moment(query.filterDate).format("YYYY-MM-DD"),
				organization: query.organization
			};
			this.queryChanges$.next(this.query);
		} else this.setQuery(this.initialQuery);
	}

	setQuery(query: IWorkorderQuery) {
		this.storageService.set("settings.workorders.query", {
			filter: query.filter,
			order: query.order,
			sort: query.sort,
			search: query.search,
			filterDate: moment(query.filterDate).format("YYYY-MM-DD"),
			organization: query.organization
		});

		this.query = query;
		this.queryChanges$.next(query);
		return query;
	}
}
